export const IconCogwheelSettings: {
  name: 'icon_cogwheel_settings-47a9ba186c78'
} = {
  name: 'icon_cogwheel_settings-47a9ba186c78'
}
